import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources';
 

i18n
  .use(initReactI18next) // Bind react-i18next to i18next
  .init({
    resources,
    lng: 'hi', // Default language
    fallbackLng: 'hi', // Fallback language if translation not found
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;